import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/household-income.png'

const DemographicsHouseholdIncome = dynamic(() => import('src/components/insights/demographics/cards/income'), {
  ssr: false,
})

export const DemographicsHouseholdIncomeWidget: InsightBuilderWidget = {
  id: 'household-income',
  name: 'Household Income',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsHouseholdIncome,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
